import classNames from "classnames";
import React from "react";
import "../../global/default.css";

interface TextButtonProps {
  // The text content of the button
  label: string;

  // The id of the button
  id: string;

  // Optional click handler
  onClick?: () => void;

  // Variant prop for style differences in A/B buttons
  variant?: "a" | "b";

  // Whether the button should be disabled visually and semantically
  disabled?: boolean;

  // Optional class override for custom styling
  className?: string;

  // accesible label for screen reader
  ariaLabel?: string;

  // a text props
  text?: string;

  // whether the button is in the choice view
  isChoiceView?: boolean;
}

export const TextButton: React.FC<TextButtonProps> = ({
  label,
  text,
  id,
  onClick,
  variant = "a",
  disabled = false,
  className = "",
  ariaLabel,
  isChoiceView = false,
}) => {
  const containerClass = classNames(
    "text-button-container",
    isChoiceView ? "text-button-container--choice-view" : "text-button-container--centered",
    { "text-button-container--with-text": Boolean(text) }
  );

  const buttonClass = classNames("text-button", `text-button--variant-${variant}`, className);

  return (
    <div className={containerClass}>
      <div className="text-button-wrapper">
        <button
          type="button"
          onClick={onClick}
          id={id}
          data-testid="text-button"
          disabled={disabled}
          aria-disabled={disabled}
          aria-label={ariaLabel || text || label}
          className={buttonClass}
        >
          {label}
        </button>
      </div>
      {text && <p className="text-button-text">{text}</p>}
    </div>
  );
};
